//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Plugin } from "ckeditor5";
import ResponseCategoryEditing from "./responseCategoryEditing";
import ResponseCategoryUi from "./responseCategoryUi";

export default class ResponseCategory extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [ResponseCategoryEditing, ResponseCategoryUi];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "ResponseCategory";
  }
}
